<template>
    <b-button
        class="btn btn-dark catalog-container__btn"
        id="btn_show_more"
        @click="paginate"
        :disabled="list_loading"
        v-if="left_product !== 0"
    >
        <b-spinner small v-if="list_loading"></b-spinner>
        <span v-else>Load {{ left_product }} more products</span>
    </b-button>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "CatalogShowMoreBtn",
    props: ["left", "section"],
    computed: {
        ...mapGetters("catalog", ["list_loading", "left_product"])
    },
    methods: {
        ...mapActions("catalog", ["paginate"]),
        ...mapMutations("catalog", ["set_section", "set_left_product"])
    },
    beforeMount() {
        this.set_section(this.section);
        this.set_left_product(this.left <= 12 ? this.left : 12);
    }
};
</script>

<style scoped></style>
